import { useNavigate, useParams } from "react-router-dom";
import { MerchantDetailPage } from "@/components/MerchantDetailPage";

export function MerchantPage() {
  const { merchantId } = useParams<{ merchantId: string }>();
  const navigate = useNavigate();
  if (!merchantId) return null;
  return (
    <MerchantDetailPage
      merchantId={merchantId}
      onBack={() => navigate("/expenses/merchants")}
      onOpenExpense={(id) => navigate(`/expenses/${id}`)}
    />
  );
}
